import { useApplication } from '@eneco/common/application';
import { NotificationBox } from '@eneco/sparky';

import { getDataErrorNotificationMessages } from '../utils/dataErrorNotificationMessages';

const DataErrorNotification = ({ locale }: { locale?: string }) => {
  const { language } = useApplication();
  const { title, text } = getDataErrorNotificationMessages(locale ?? language);

  return <NotificationBox isAlert={false} title={title} text={text} variant={'error'}></NotificationBox>;
};

export default DataErrorNotification;
